import { render, staticRenderFns } from "./select-fleet.vue?vue&type=template&id=5923f8ad&scoped=true"
import script from "./select-fleet.vue?vue&type=script&lang=js"
export * from "./select-fleet.vue?vue&type=script&lang=js"
import style0 from "./select-fleet.vue?vue&type=style&index=0&id=5923f8ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5923f8ad",
  null
  
)

export default component.exports